<template>
  <div>
    <div id="header">
      <img class="header-bg" src="../../assets/health/health.jpg" alt="">
      <div class="header-info">
        <div class="info-l">
          <p>{{num}}</p>
          <p>血压（mmHg）</p>
        </div>
        <div class="info-r">
          <img :src='headimg' alt="">
          <p>{{name}}</p>
          <p>{{create_time}}</p>
        </div>
      </div>
    </div>
    <div id="content">
      <div class="main" id="main"></div>
      <div class="count">
        <div>
          <p class="val">{{max}}</p>
          <p class="title">最高/mmHg</p>
        </div>
        <div style="border-left: 2px solid #fff;border-right: 2px solid #fff;">
          <p class="val">{{avg}}</p>
          <p class="title">平均/mmHg</p>
        </div>
        <div>
          <p class="val">{{min}}</p>
          <p class="title">最低/mmHg</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import { bloodPressure } from '../../api/health';

  let echarts = require('echarts/lib/echarts');
  // 引入柱状图组件
  require('echarts/lib/chart/line');

  // 引入提示框和title组件
  require('echarts/lib/component/title');
  require('echarts/lib/component/dataZoom');
  require('echarts/lib/component/tooltip');

  export default {
    name: "heartRate",
    data() {
      return {
          max: '0/0',
          avg: '0/0',
          min: '0/0',
          num: '0/0',
          name: '',
          create_time: '',
          headimg: ''
      };
    },
    mounted(){
      let _this = this;
        document.title = '血压-健康管理';

      bloodPressure({token: this.$route.query.token})
              .then(res => {
                  if (res.code === 1) {
                      var X = [];var Y1 = [];var Y2 = [];
                      res.content.list.forEach(function (item) {
                          X.push(item.time);
                          Y1.push(item.sdp);
                          Y2.push(item.dbp);
                      });
                      this.drawLine(X, Y1, Y2, res.content.info.type);
                      _this.max = res.content.count.sdp_max + '/' + res.content.count.dbp_max;
                      _this.avg = res.content.count.sdp_avg + '/' + res.content.count.dbp_avg;
                      _this.min = res.content.count.sdp_min + '/' + res.content.count.dbp_min;
                      _this.num         = res.content.info.sdp + '/' + res.content.info.dbp;
                      _this.name        = res.content.info.name;
                      _this.headimg     = res.content.info.headimg;
                      _this.create_time = res.content.info.create_time;
                  }
              })
          .catch(() => {})
          .finally(() => {});
    },
      methods: {
          drawLine(data, Y1, Y2){
              // 基于准备好的dom，初始化echarts实例
              let myChart = echarts.init(document.getElementById('main'))
              // 绘制图表
              myChart.setOption({
                title: {
                  show: false
                },
                grid: {
                  top: 30,
                  bottom: 50,
                  left: '10%',
                  right: '2%'
                },
                tooltip : {
                  trigger: 'axis',
                  axisPointer: {
                    type: 'cross',
                    label: {
                      backgroundColor: '#6a7985'
                    }
                  }
                },
                xAxis : [
                  {
                    type : 'category',
                    boundaryGap : false,
                    data : data
                  }
                ],
                yAxis : [
                  {
                    type : 'value',
                    axisLabel : {
                      formatter: '{value}'
                    }
                  }
                ],
                dataZoom: [
                  {
                    type: 'slider',//图表下方的伸缩条
                    show : true, //是否显示
                    realtime : false, //拖动时，是否实时更新系列的视图
                    start : 0, //伸缩条开始位置（1-100），可以随时更改
                    end : 20, //伸缩条结束位置（1-100），可以随时更改
                  }
                ],
                series: [{
                  name:'收缩压',
                  type:'line',
                  data:Y1,
                  connectNulls:true
                },
                {
                  name:'舒张压',
                  type:'line',
                  data:Y2,
                  connectNulls:true
                }]
              });
          }
      }
  };

</script>
<style lang="scss" scoped>
  #header{
    width: 100%;
    height: 500px;
  }
  #header .header-bg{
    width: 100%;
  }
  #header .header-info .info-l{
    float: left;
    padding-left: 15px;
    padding-top: 5px;
    text-align: center;
  }
  #header .header-info .info-l p:nth-child(1){
    font-weight:bold;
    color: #333;
    font-size: 24px;
  }
  #header .header-info .info-l p:nth-child(2){
    color: #999;
    font-size: 13px;
  }
  #header .header-info .info-r{
    float: right;
    text-align: right;
    font-family:PingFang SC;
    position: absolute;
    right: 15px;
    top: 388px;
  }
  #header .header-info .info-r img{
    width: 67px;
    height: 67px;
    border-radius: 50%;
  }
  #header .header-info .info-r p:nth-child(2){
    font-weight:bold;
    color: #333;
    font-size: 15px;
  }
  #header .header-info .info-r p:nth-child(3){
    color: #999;
    font-size: 13px;
  }
  #content{
    width: 95%;
    margin: 0 auto;
    margin-bottom: 20px;
  }
  #content .main{
    height: 300px;
  }
  #content .count{
    height: 100px;
    margin: 0 auto;
    background-color: #bfefdf77;
    border-radius:8px;
  }
  #content .count div{
    float: left;
    width: 32.9%;
    height: 100px;
    text-align: center;
  }
  #content .count .val{
    padding-top: 20px;
    font-size: 22px;
    color: #666666;
  }
  #content .count .title{
    font-size: 15px;
    color: #cccccc;
  }
</style>
